<template>
  <div class="saved-notice">
    <img :src="asset('/imgs/icons/saved-check.png')" alt="saved" /> Saved!
  </div>
</template>
<script>
export default {
  name: 'SavedNotice',
};
</script>
